import { Severity } from '@/stores/messages/messages-model';
import axios from 'axios';
import MessagesStore from '@/stores/messages/messages-module';

export default function setupInterceptors(): void {
  axios.defaults.withCredentials = false;
  axios.defaults.params = {};

  // axios.interceptors.request.use((request) => {
  //   // TODO remove this once the cookie problems are fixed
  //   request.params.anonymous = true;
  //   return request;
  // }, (err) => {
  //   return Promise.reject(err);
  // });

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (axios.isCancel(error)) {
        MessagesStore.addMessage({
          text: 'Die Anfrage an den Server wurde abgebrochen.',
          severity: Severity.WARNING,
        });
        return Promise.reject(error);
      }
      if (axios.isAxiosError(error)) {
        MessagesStore.addMessage({
          text: 'Ein Fehler ist aufgetreten. Wir kümmern uns um eine schnellstmögliche Behebung.',
          severity: Severity.ERROR,
          timeout: 99999999999,
        });
        return Promise.reject(error);
      }

      MessagesStore.addMessage({
        text: 'Die Anfrage lieferte folgenden Fehler: ' + error.message,
        severity: Severity.ERROR,
        timeout: 10000,
      });
      console.log('reject');
      console.log(error.message);
      console.log(error.code);
      console.log(error.request);
      console.log(error.response);
      console.log(error.config);
      return Promise.reject(error);
    }
  );
}
